const LangEgiftCardRedemption = {
	"egiftCardRedemption.createMyAccount": ["Create My Account", "Tạo tài khoản mới"],
	"egiftCardRedemption.collectMoreStars": [
		"Collect more Stars and earn rewards by creating an account with Starbucks! A great way to know about offers and what's new from Starbucks. Know about initiatives, announcements and product offers when you create an account.",
		"Tích lũy điểm ngôi sao và quà thưởng bằng cách tạo ngay tài khoản Starbucks. Bạn sẽ dễ dàng biết được các chương trình khuyến mãi cũng như thông tin sản phẩm mới nhất đến từ Starbucks. Các thông tin, thông báo mới sẽ được gửi đến bạn khi bạn có tài khoản cùng chúng tôi.",
	],
	"egiftCardRedemption.emailAddress": ["E-mail address", "Địa chỉ email"],
	"egiftCardRedemption.claimMyEgift": ["Claim my E-Gift", "Nhận quà"],
	"egiftCardRedemption.emailMe": ["E-mail me", "Gửi email<br/> cho tôi"],
	"egiftCardRedemption.saveAsImage": ["Save as image", "Lưu hình ảnh"],
	"egiftCardRedemption.forgotYour": ["Forgot your", "Quên"],
	"egiftCardRedemption.easyToUseYour": [
		"Easy to use your E-gift by keeping it in your email or image",
		"Dễ dàng sử dụng quà tặng bằng cách nhận thẻ qua email hoặc lưu vào máy bằng hình ảnh",
	],
	"egiftCardRedemption.howToRedeem": [
		"How would you like to redeem your eGift",
		"Bạn muốn nhận thẻ quà tặng bằng cách nào?",
	],
	"egiftCardRedemption.selectRedeemMethod": [
		"Please select the way you want to redeem your eGift",
		"Vui lòng chọn cách thức nhận thẻ quà tặng của bạn",
	],
	"egiftCardRedemption.redeemOnMobileApp": [
		"Redeem your egift on Starbucks® Mobile App",
		"Xác nhận thẻ quà tặng bằng ứng dụng Starbucks VN",
	],
	"egiftCardRedemption.pleaseDownloadApp": [
		"Please download the Starbucks VN app and register as a Starbucks Rewards member.",
		"Vui lòng tải ứng dụng Starbucks VN và đăng ký tài khoản thành viên Starbucks Rewards",
	],
	"egiftCardRedemption.claimYourEgiftCard": [
		"Claim your Starbucks® eGift Card",
		"Nhận thẻ quà tặng của bạn",
	],
	"egiftCardRedemption.easyToUseYourMobile": [
		"Easy to use your eGift by keeping it in your email or save the image to redeem at Starbucks store",
		"Dễ dàng sử dụng quà tặng bằng cách nhận thẻ qua email hoặc lưu vào máy bằng hình ảnh",
	],
	"egiftCardRedemption.redeemNow": ["Redeem now", "Nhận quà ngay"],
	"egiftCardRedemption.emailMeMobile": ["Email me", "Gửi email cho tôi"],
	"egiftCardRedemptionPopup.button._close": ["Close", "Đóng"],
	"egiftCardRedemptionPopup.button._saveAsPdf": ["Print Now", "In Ngay"],
	"egiftCardRedemptionPopup.securityCode": ["Security Code", "Security Code"],
}

export default LangEgiftCardRedemption
